import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
// Source: https://usehooks.com/useWindowSize
export var useWindowSize = _ref => {
  var {
    isDisabled = false,
    debounce: timeout = 500
  } = _ref;
  var [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  useEffect(() => {
    if (isDisabled) return;
    var handleResize = debounce(() => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }, timeout);
    window.addEventListener('resize', handleResize);
    return () => {
      setWindowSize({
        width: undefined,
        height: undefined
      });
      window.removeEventListener('resize', handleResize);
    }; // Empty array ensures that effect is only run on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return windowSize;
};
//# sourceMappingURL=useWindowSize.js.map